import { render, staticRenderFns } from "./settlement.vue?vue&type=template&id=5afdbdd4&scoped=true"
import script from "./settlement.vue?vue&type=script&lang=js"
export * from "./settlement.vue?vue&type=script&lang=js"
import style0 from "./settlement.vue?vue&type=style&index=0&id=5afdbdd4&prod&lang=stylus&scoped=true"
import style1 from "./settlement.vue?vue&type=style&index=1&id=5afdbdd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afdbdd4",
  null
  
)

export default component.exports